import { Box, Divider, Skeleton, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { ParsedResultSet } from "../../workout/utils";
import WorkoutSetTable from "./WorkoutSetTable";
import { ExerciseTypeSet, JourneyAnchors, Units } from "../../../constants";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: 20,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    gap: theme.spacing(2),
    fontSize: 14,
    maxHeight: 650,
    overflowY: "auto",
  },
  title: {
    fontWeight: 600,
    fontSize: 14,
  },
}));

interface IWorkoutHistoryContainer {
  resultSets?: ParsedResultSet[];
  isLoading: boolean;
  exerciseTypeSet: ExerciseTypeSet;
  units: Units;
}

const WorkoutHistoryContainer = ({
  resultSets,
  isLoading,
  exerciseTypeSet,
  units,
}: IWorkoutHistoryContainer) => {
  const s = useStyles();

  return (
    <Box className={clsx(s.root, JourneyAnchors.EXERCISE_HISTORY_LOGS)}>
      <Typography className={s.title}>Workout History</Typography>
      {isLoading ? (
        <Skeleton variant="text" animation="wave" />
      ) : (
        <>
          {resultSets.length === 0 && !isLoading && (
            <Typography>No results...</Typography>
          )}
          {resultSets.length > 0 &&
            !isLoading &&
            resultSets.map(
              ({ sets, completedAt, exerciseTypeExtraMeasurement }, index) => (
                <React.Fragment key={index}>
                  <WorkoutSetTable
                    sets={sets}
                    completedAt={completedAt}
                    exerciseTypeSet={exerciseTypeSet}
                    exerciseTypeExtraMeasurement={exerciseTypeExtraMeasurement}
                    units={units}
                  />
                  {resultSets.length - 1 !== index && <Divider />}
                </React.Fragment>
              ),
            )}
        </>
      )}
    </Box>
  );
};

export default WorkoutHistoryContainer;
